import { render, staticRenderFns } from "./MarketplaceForm.vue?vue&type=template&id=3a16baac&"
import script from "./MarketplaceForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports